<header class="site-header content-box clearfix no-print">
	<h1 class="float-left">
		<a routerLink="/dashboard" class="branding">
			<img src="/assets/img/recog-logo.png" class="branding-img" width="80" height="50"> 
			<span class="branding-name">ReCog</span>
		</a>
	</h1>

	<div class="float-right">
		<!-- TODO: Figure out what dropdown sign in doesn't work, other sign in does-->

		<button *ngIf="user" (click)="open(createThought, thoughtModalOptions)" class="unbtn create-thought">
			<img src="/assets/img/thought.svg" class="create-thought-bubble"> 
			<i class="fa fa-plus create-thought-plus" aria-hidden="true"></i>
		</button>

		<button (click)="open(help, helpModalOptions)" class="help-link btn btn-link mr-2">
			<i class="fa fa-question" aria-hidden="true"></i>
		</button>
	
		
		<div ngbDropdown *ngIf="user" class="d-inline-block">
			  <button class="btn btn-outline-secondary" id="userDropDown" ngbDropdownToggle>{{user?.firstName}}</button>
			  <div class="dropdown-menu" aria-labelledby="userDropDown" ngbDropdownMenu>
				<a class="dropdown-item" routerLink="/templates">Thought Templates</a>
				<div class="dropdown-divider"></div>
				<!-- TODO: Enable integrations -->
				<!-- <a routerLink="/integrations" class="dropdown-item">Import Thoughts</a> -->
				<!-- TODO: Enable networks -->
				<!-- <div class="dropdown-divider" *ngIf="userNetworks?.length > 0"></div>
				<h6 class="dropdown-header" *ngIf="userNetworks?.length > 0">Networks</h6>
				<a class="dropdown-item" *ngFor="let network of userNetworks" [routerLink]="['/networks/', network.uid]">{{network.name}}</a>
				<div class="dropdown-divider" *ngIf="userNetworks?.length > 0"></div> -->
				<a href="/" (click)="userService.signout()" class="dropdown-item" >Sign Out</a>
			  </div>
		</div>
	</div>
</header>

<section class="messages no-print">
	<div class="network-invites alert alert-warning" *ngIf="networkInvites?.length > 0">
		<ul class="network-invite-list list-unstyled">
			<li class="network-invite pt-2 pb-2" *ngFor="let networkInvite of networkInvites ">
				You have been invited to join <strong>{{networkInvite.name}}</strong>
				<button (click)="acceptInvite(networkInvite)" class="btn btn-primary btn-sm">Join Network</button>
				<button (click)="rejectInvite(networkInvite)" class="btn btn-danger btn-sm">Reject Invite</button>
			</li>
		</ul>
	</div>
</section>

<ng-template #createThought>
	<div class="modal-header thought-bg">
		<h2 class="modal-title">Create a Thought</h2>
	</div>
	<div class="modal-body create-thought-modal">
		<app-thought-form
			(thoughtSaved)="thoughtSaved($event)"
			(thoughtCancelled)="thoughtCancelled($event)"
			(modalIsOpen)="toggleCreateThoughtModal($event)"
			class="pb-4"></app-thought-form>
	</div>
</ng-template>

<ng-template #help let-d="dismiss">
	<div class="modal-header default-bg">
		<h2 class="modal-title">Where to Start</h2>
		<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<h4 class="header-minor thought-bg">Create some thoughts</h4>
		<p>Thoughts are free-form documents where you can put all of your related information in one place: text, numbers, pictures, dates, checklists.</p>
		<ol>
			<li>Click the <img src="/assets/img/thought.svg" class="create-thought-bubble" width="20">  button in the <em>header</em>.</li>
			<li>Give your new thought a title.</li>
			<li>Click <strong class="fa fa-plus" aria-hidden="true"></strong> button at the bottom of the screen to add different types of info to your thought.</li>
			<li>Add a tag, if you like.</li>
			<li>Click <strong>Save</strong>.</li>
		</ol>
		<p>You can view thoughts from the <em>dashboard</em>, the <em>thought search page</em>, or a collection. When viewing a thought, you can edit it by clicking the <i class="fa fa-pencil" aria-hidden="true"></i> icon to the right of the title.</p>

		<h4 class="header-minor thought-bg">Create a Thought Template</h4>
		<p>Templates allow you to save thought data to reuse in future thoughts.
			Templates are non-destructive: template titles will only be applied if a thought does not already have a title. Info is always added, it never replaces existing info. Tags will be added, if the thought does not already have the exact same tag.</p>
		<ol>
			<li>Edit or begin creating a thought.</li>
			<li>Click <strong class="fa fa-clone" aria-hidden="true"></strong> at the bottom of the thought form. You'll see a <em>Thought Templates</em> popup.</li>
			<li>In the <strong>Save As Template</strong> section, type a name for your thought template. You can type a new template name or update an existing template.</li>
			<li>Click <strong>Save as ...</strong> at the bottom of the <em>Thought Templates</em> popup..</li>
			<li>You can apply the template to a thought by
				<ul>
					<li>Clicking <strong class="fa fa-clone" aria-hidden="true"></strong> at the bottom of a thought form.</li>
					<li>Checking any templates you want to apply.</li>
					<li>Click <strong>Apply Templates</strong>.</li>
				</ul>
			</li>
		</ol>
		<p>You can view and edit thought templates by clicking your name in the header, and selecting <strong>Thought Templates</strong>.</p>

		<h4 class="header-minor thought-bg">Search Thoughts</h4>
		<p>You can search your thoughts by clicking the <i class="fa-fa-search" aria-hidden="true"></i> icon from the <em>Recents Thoughts</em> area of your <em>Dashboard</em>.</p>
		<ol>
			<li>Try a simple text search that updates as you type.</li>
			<li>Click <i class="fa fa-filter" aria-hidden="true"></i> to try an advanced search that allows you to filter specifically by title, info, tag, date created, or date updated.</li>
			<li>Click <i class="fa fa-pencil" aria-hidden="true"></i><i class="fa fa-pencil" aria-hidden="true"></i> button to be able to edit multiple thoughts at once.</li>
		</ol>

		<h4 class="header-minor collection-bg">Create a Collection</h4>
		<p>Collections are like saved searches. They automatically pick up new or edited thoughts that match their filters. You can views to collections to show your thoughts in different formats.</p>
		<ol>
			<li>Click the <i class="fa fa-plus" aria-hidden="true"></i> icon in the <em>Collections</em> section of your <em>Dashboard</em>.</li>
			<li>Add a title.</li>
			<li>Add a description to give your collection context (optional).</li>
			<li>Add filters to your collection. These filters work just like <em>Advanced Search</em> on the <em>Thought Search Page</em>.</li>
			<li>Create a view. By default, you have a list view that shows only the title of each thought.
				<ol>
					<li>Give your view a title. If you have more than one view, you'll be able select views by title on a collection page.</li>
					<li>Select a view type.</li>
					<li>Add view variables: these are the labels of info you want to appear in your view.</li>
					<li>If your view has any additional settings, experiment with them.</li>
				</ol>
			</li>
			<li>Click <strong>Save Collection</strong></li>
		</ol>
		<p>You can view your collections from the <em>Collections</em> section of your <em>Dashoard</em>. To edit a collection, click the collection's name on the Dashboard. Then click the <i class="fa fa-pencil" aria-hidden="true"></i> to the right of the title.</p>

	</div>
</ng-template>

<!-- <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="svgThought">
    <title>Bubble / Thought</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <path d="M5.5,36 C3.01471863,36 1,33.9852814 1,31.5 C1,29.0147186 3.01471863,27 5.5,27 C7.98528137,27 10,29.0147186 10,31.5 C10,33.9852814 7.98528137,36 5.5,36 Z M5.5,34 C6.88071187,34 8,32.8807119 8,31.5 C8,30.1192881 6.88071187,29 5.5,29 C4.11928813,29 3,30.1192881 3,31.5 C3,32.8807119 4.11928813,34 5.5,34 Z M3.5,41 C1.56700338,41 0,39.4329966 0,37.5 C0,35.5670034 1.56700338,34 3.5,34 C5.43299662,34 7,35.5670034 7,37.5 C7,39.4329966 5.43299662,41 3.5,41 Z M3.5,39 C4.32842712,39 5,38.3284271 5,37.5 C5,36.6715729 4.32842712,36 3.5,36 C2.67157288,36 2,36.6715729 2,37.5 C2,38.3284271 2.67157288,39 3.5,39 Z M5.80314857,14.2836803 C5.4478364,14.9723935 5.70534475,16.5278204 6.87889119,18.8910607 L7.64959703,20.4430769 L6.22315527,21.4269496 C3.9506953,22.9943543 3.66935109,23.7490783 4.34571813,24.5360845 C5.47293932,25.8476948 6.88421916,26.277846 8.88581415,25.8549699 L11.2572147,25.3539652 L11.2989314,27.7773525 C11.3409176,30.2163998 12.0846502,31.409122 13.6031487,31.8694624 C15.2111781,32.3569445 17.3941129,31.4810848 20.1760194,28.9012745 L21.5700703,27.6084969 L22.931739,28.935339 C25.8977009,31.8254422 27.9083514,32.4487391 29.3062338,31.483237 C31.1779433,30.1904677 32.1423888,28.5153564 32.2962243,26.3055737 L32.4668784,23.8541972 L34.8325321,24.5190673 C36.4542518,24.9748538 37.2270495,24.7416403 37.7372789,23.8719507 C38.0815463,23.2851445 37.5511086,22.2450251 35.2284982,20.5238566 L33.4228619,19.1857913 L34.9615039,17.5477064 C37.0492455,15.3250333 37.4659511,13.8555105 36.7823884,12.7974083 C35.9189081,11.4608077 34.731826,10.9298415 32.8971054,11.1200006 L30.3942563,11.3794078 L30.7063652,8.88258301 C30.9528461,6.91077301 30.2284702,5.54740818 28.2967289,4.45452381 C26.628396,3.51066295 25.0713199,4.01058555 23.090826,6.45856627 L21.4867543,8.44127213 L19.9436214,6.4107772 C18.3481451,4.31140753 16.6217459,3.7882347 14.2740066,4.66263881 C12.0553669,5.48896041 11.2394,7.20490625 11.7518394,10.4693466 L12.0782559,12.5487482 L9.98489993,12.7685649 C7.47513858,13.0321069 6.13860892,13.6334465 5.80314857,14.2836803 Z M2.24834472,12.4497311 C3.14888635,10.7041817 4.96927913,9.6351492 7.61684053,9.08710415 C7.53465689,5.10993948 9.30417633,2.24520368 12.8779124,0.914182998 C16.1420251,-0.301519978 19.116672,0.185725221 21.5391513,2.28023723 C24.2608231,-0.18552716 27.274284,-0.719704378 30.2663655,0.973068388 C32.8688772,2.44544175 34.3825609,4.55993121 34.692739,7.1526652 C36.9731916,7.43751087 38.8381546,8.60820979 40.1422491,10.6268471 C41.7246639,13.0763026 41.3102388,15.8210691 39.2374953,18.6584674 C41.7668642,21.034034 42.598032,23.4915404 41.1873586,25.8960431 C40.0295319,27.8695669 38.1923606,28.8057043 35.9383211,28.727967 C35.2912502,31.1851736 33.8228656,33.2250089 31.579471,34.774497 C28.605607,36.8285124 25.1671416,36.0895423 21.5056675,33.0357793 C18.306364,35.5944755 15.2800071,36.5575768 12.442682,35.6974276 C9.73955433,34.8779609 8.08511205,32.8905413 7.5182485,30.0089168 C5.06800386,30.0104381 2.95148087,29.0507694 1.31210427,27.143226 C-0.935352384,24.5281337 -0.268893924,21.6793393 2.61380315,19.1672979 C1.51008673,16.4634453 1.32668249,14.2362193 2.24834472,12.4497311 Z" id="path-1"></path>
    </defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Bubble-/-Thought">
            <g id="Thought-Bubble-/-Blue" transform="translate(-1.000000, -1.000000)"></g>
            <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
            </mask>
            <use id="Path-2" fill="#3FA9F5" fill-rule="nonzero" xlink:href="#path-1"></use>
            <g id="color/blue" mask="url(#mask-2)" fill="#3FA9F5">
                <rect id="Rectangle-2" x="0" y="0" width="42" height="42"></rect>
            </g>
        </g>
    </g>
</svg> -->
